

function Withdraw(props) {
  return (
    <svg className={props.className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 6L18 6V16H15V11.23L8.02 18L6 15.97L12.85 9L8 9V6Z" fill={props.fill}/>
</svg>
  )
}

export default Withdraw